import { InjectionToken } from '@angular/core';
import { PaymentMethodCreateParams, StripeElementsOptions, StripePaymentElementOptions } from '@stripe/stripe-js';
import { StripeMode, StripePaymentDetails } from '@ag-common-lib/public-api';
import { FirebaseApp } from 'firebase/app';

export class StripeModalPayload {
  amountToPay: number;
  stripeMode: StripeMode;
  billingDetails?: PaymentMethodCreateParams.BillingDetails;
}

export enum StripeModalUserActionType {
  success = 'success',
  cancel = 'cancel',
}

export class StripeModalUserAction {
  type: StripeModalUserActionType;
  payload?: StripePaymentDetails;
}

export const STRIPE_PUBLIC_KEY_LIVE = new InjectionToken<FirebaseApp>('STRIPE_PUBLIC_KEY_LIVE');
export const STRIPE_PUBLIC_KEY_TEST = new InjectionToken<FirebaseApp>('STRIPE_PUBLIC_KEY_TEST');

export const elementsOptions: StripeElementsOptions = {
  locale: 'en',
  appearance: {
    theme: 'flat',
    labels: 'floating',
  },
};

export const paymentElementOptions: StripePaymentElementOptions = {
  layout: {
    type: 'tabs',
    defaultCollapsed: false,
    radios: false,
    spacedAccordionItems: false,
  },
  defaultValues: {
    billingDetails: {
      name: 'Jane Doe',
    },
  },
  fields: {
    billingDetails: {
      name: 'auto',
      email: 'auto',
      phone: 'auto',
      address: 'auto',
    },
  },
  wallets: { applePay: 'never', googlePay: 'never' },
};
